<div class="container-fluid" *ngIf="!isCalculoCuota">
  <!-- start page title -->
  <div class="row">
    <div class="col-12">
        <div class="page-title-box">
            <div class="page-title-right">
              <a href="#/panel-admin" class="btn btn-primary">
                Volver
              </a>
            </div>
            <h3 class="page-title">Cálculo de Cuota Anual</h3>
        </div>
    </div>
  </div>

  <!-- Invoice Logo-->
  <div class="row">
    <div class="col-md-6">
      <label for="busca" class="col-form-label">Bucar empresa</label>
      <input
        class="form-control"
        type="text"
        id="buscar"
        placeholder="Buscar..."
        [(ngModel)]="searchTerm"
        (input)="buscar()"
      >
    </div>
    <div class="col-md-6">
      <label for="estadol" class="col-form-label">Estado</label>
      <select class="form-select" id="estado" name="estado" (change)="consulta_combos()">
        <option *ngFor="let ed of estado" [value]="ed.id_estado" [selected]="ed.id_estado == sel_edo ? true : false">
          {{ed.nombre}}
        </option>
      </select>
    </div>
  </div>
  <hr class="text-dark">

  <!-- end page title  -->

  <div class="row">
    <div class="col-12">
      <table class="table">
        <thead>
          <tr class="table-primary">
            <th scope="col">N°</th>
            <th scope="col">Rif</th>
            <th scope="col">Razón Social</th>
            <th scope="col">Tipo</th>
            <th scope="col">Estados</th>
            <th scope="col">Acción</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let r of filteredResultado; let i = index">
            <th scope="row">{{i+1}}</th>
            <td>{{r.identificacion}}</td>
            <td>{{r.nombre}}</td>
            <td>C.A/S.A/S.A.C.A/S.R.L</td>
            <td>{{r.estado}}</td>
            <td>
              <a style="cursor: pointer;" class="btn btn-sm btn-primary" (click)="enviar(r.id_organizacion, r.identificacion, r.nombre, r.id_estado)">Seleccionar</a>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>


</div>

<app-modal [titulo]="titulo" [tipo_color]="tipo_color" [letra_color]="letra_color" [mensaje]="mensaje"></app-modal>

<app-calculo-cuota *ngIf="isCalculoCuota"
[id_empresa]="id_organizacion"
[nombre_empresa]="nombre_organizacion"
[rif]="identificacion"
[id_estado]="id_estado"
[arrEstado]="estado"
(vuelve)="volver($event)"
></app-calculo-cuota>

